import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  fetchSettingsApi,
  fetchNotificationSettingsApi,
  updateNotificationSettingsApi,
  fetchFeedbackSupportOptionsApi,
  fetchSubmitFeedbackApi,
  fetchCookieConsentApi,
  updateCookieConsentApi
} from '../api/settingsApi'

export const useSettings = (options = {}) => {
  const userId = JSON.parse(localStorage.getItem('user')) || ''
  return useQuery({
    queryKey: ['GET_SETTINGS', userId],
    queryFn: async () => {
      const resp = await fetchSettingsApi()
      return resp
    },
    ...options
  })
}
export const useSettingsNotification = ( options = {}) => {
  return useQuery({
    queryKey: ['NOTIFICATION_SETTINGS'],
    queryFn: async () => {
      const resp = await fetchNotificationSettingsApi()
      return resp
    },
    staleTime: 0,
    ...options
  })
}

export const useUpdateNotificationSettings = (options = {}) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['UPDATE_NOTIFICATION_SETTINGS'],
    mutationFn: async (data) => {
      const resp = await updateNotificationSettingsApi(data)
      return resp
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['NOTIFICATION_SETTINGS']
      })
    },
    ...options
  })
}

export const useFeedbackSupportOptions = (options = {}, data) => {
  return useQuery({
    queryKey: ['FEEDBACK_SUPPORT_OPTIONS'],
    queryFn: async () => {
      const resp = await fetchFeedbackSupportOptionsApi(data)
      return resp
    },
    staleTime: 0,
    ...options
  })
}

// export const useSubmitFeedback = (options = {}) => {
//     return useQuery({
//         queryKey: ['SUBMIT_FEEDBACK'],
//         queryFn: async () => {
//             const resp = await fetchSubmitFeedbackApi()
//             return resp
//         },
//         staleTime: 0,
//         ...options
//     })
// }

export const useSubmitFeedback = (options = {}) => {
  return useMutation({
    mutationFn: (formData) => fetchSubmitFeedbackApi(formData),
    ...options
  })
}

export const useFetchCookieConsent = (options = {}) => {
  const deviceId = localStorage.getItem('deviceId')
  return useQuery({
    queryKey: ['GET_COOKIE_CONSENT', deviceId],
    queryFn: async () => {
      const resp = await fetchCookieConsentApi()
      return resp
    },
    enabled: !!deviceId,
    staleTime: 0,
    ...options
  })
}

export const useUpdateCookieConsent = (options = {}) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => updateCookieConsentApi(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['GET_COOKIE_CONSENT'] })
    },
    ...options
  })
}
